import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import routes from './router';
//import VueApexCharts from 'vue-apexcharts'
//import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import CodeDiff from 'v-code-diff'

Vue.use(CodeDiff);
Vue.use(VueRouter);
//Vue.use(VueApexCharts)

//Vue.component('Apexchart', VueApexCharts)
const router = new VueRouter({routes});
Vue.config.devtools = process.env.NODE_ENV === 'dev';

router.beforeEach((toRoute, fromRoute, next) => {
    store.commit('SET_ROUTE', toRoute);
    window.document.title = toRoute.meta && toRoute.meta.title ? toRoute.meta.title : 'Molten-Core Ad Control';
    next();
})

Vue.config.warnHandler = function (err, vm, info) {
    if (err.indexOf("Invalid prop: type check failed for prop \"searchInput\". Expected String with value") === -1) {
        console.error('[Vue warn]: ', err, vm.name, info);
    }
};

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');
